import styles from "../Components/ProductList.module.css"
const PlacedOrderSuccessfully = () => {
  localStorage.removeItem('cartList')
    return (
      <>
        <div className={`col-sm-12 ${styles.mainContainer}`}>
          <div class="container-fluid">
            <div class="col-sm-10">
              Your order booked successsfully
              <br />
              We will deliver very shortly
              <br /> Thank you.
            </div>
          </div>
        </div>
      </>
    );
}
export default PlacedOrderSuccessfully